export const zh_cn = {
  translation: {
    common: {
      retry: "重试",
    },
    login: {
      document_title: "登录 - 明森 ERP",
      title: "欢迎登录",
      subtitle: "请输入用户名和密码登录系统",
      company_label: "当前登录企业",
      company_loading: "正在读取企业信息…",
      company_fallback: "企业专属管理系统",
      username: "用户名",
      username_placeholder: "请输入用户名",
      username_required: "请输入用户名",
      password: "密码",
      password_placeholder: "请输入密码",
      password_required: "请输入密码",
      remember_me: "保持登录",
      submit: "登录",
      initial_password_title: "请先注意账号安全",
      continue_to_app: "继续进入系统",
    },
    shell: {
      document_title: "工作台 - 明森 ERP",
      product_name: "明森 ERP",
      product_caption: "企业管理系统",
      home: "首页",
      collapse: "收起导航",
      expand: "展开导航",
      user_menu: "用户菜单",
      logout: "退出登录",
      menu_load_failed: "菜单加载失败",
    },
    home: {
      eyebrow: "WORKBENCH",
      greeting: "你好，{{username}}",
      description: "欢迎使用明森 ERP，请从左侧导航进入业务模块。",
      available_modules: "可用模块",
      module_count_suffix: "个模块",
      no_available_modules: "当前账号暂无可用模块",
      current_account: "当前账号",
      standard_user: "系统用户",
    },
  },
} as const;
